// ============================================================================
// COMMON HOOKS
// ============================================================================
export { useCaretPosition } from './common/useCaretPosition';
export { useDebounce } from './common/useDebounce';
export type { CaretPosition } from './common/useCaretPosition';

// ============================================================================
// EDIT HOOKS
// ============================================================================
export { useEditManager, useSingleEdit } from './edit/useEditManager';
export { useFormManager, useSingleForm } from './edit/useFormManager';
export { useEditPermission } from './edit/useEditPermission';

// ============================================================================
// EVENT HOOKS
// ============================================================================
export { useInputFocus } from './events/useInputFocus';
export { useKeyboardNavigation } from './events/useKeyboardNavigation';

// ============================================================================
// MENTION HOOKS
// ============================================================================
export { useAvatar, getInitials, getAvatarColor } from './mentions/useAvatar';
export { useMentionInteractions } from './mentions/useMentionInteractions';
export { useMentions } from './mentions/useMentions';
export { useMostRecentMention } from './mentions/useMostRecentMention';
export { useTextParsing } from './mentions/useTextParsing';

// ============================================================================
// MENU HOOKS
// ============================================================================
export { useCommentMenu } from './menu/useCommentMenu';

// ============================================================================
// TIMESTAMP HOOKS
// ============================================================================
export { useLocalTimestamp } from './timestamp/useLocalTimestamp';

// ============================================================================
// ATTACHMENTS (file upload – Add Comment, Reply, Edit)
// ============================================================================
export { useAttachments } from './useAttachments';
export type { UseAttachmentsOptions } from './useAttachments';
export { useViewerAttachmentCarousel } from './useViewerAttachmentCarousel';
export type { UseViewerAttachmentCarouselResult } from './useViewerAttachmentCarousel';

// ============================================================================
// COMMENT LIST / LOAD MORE
// ============================================================================
export {
  useGetCommentInitialPageStart,
  type UseGetCommentInitialPageStartOptions,
  type GetCommentInitialPageStartResult
} from './useGetCommentInitialPageStart';
export {
  useLoadWhenVisible,
  type UseLoadWhenVisibleOptions
} from './useLoadWhenVisible';

// ============================================================================
// TYPE EXPORTS
// ============================================================================
export type { Mention, MentionPopupState } from './mentions/useMentions';
export type {
  MentionMatch,
  TextPart as ParsedTextPart
} from './mentions/useTextParsing';
export type { CommentMention } from '../containers/CommentList/CommentList.types';
